import { createFileRoute, useParams } from '@tanstack/react-router'

import { ServiceHistoryDetail } from '../../../components/service-history/components/ServiceHistoryDetail'

export const Route = createFileRoute('/app/service-history/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = useParams({ from: '/app/service-history/$id' })
  return <ServiceHistoryDetail requestId={id} />
}
